import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import type { RangeParam } from '@/types/analytics';

interface TimeRangeTabsProps {
  value: RangeParam;
  onChange: (value: RangeParam) => void;
  className?: string;
}

const RANGES: { value: RangeParam; label: string }[] = [
  { value: '7d', label: '7d' },
  { value: '30d', label: '30d' },
  { value: '90d', label: '90d' },
  { value: 'all', label: 'All' },
];

export function TimeRangeTabs({ value, onChange, className }: TimeRangeTabsProps) {
  return (
    <Tabs
      value={value}
      onValueChange={(v) => onChange(v as RangeParam)}
      className={className}
    >
      <TabsList>
        {RANGES.map((r) => (
          <TabsTrigger key={r.value} value={r.value}>
            {r.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
